// @ts-nocheck
import useSWRMutation, { SWRMutationResponse } from "swr/mutation";
import useHttpClient from "../useHttpClient";
import { AxiosInstance } from "axios";
import { OtpType } from "/src/types";

export interface RequestOTPArgs {
  type: OtpType;
}

const useRequestOTP = (): SWRMutationResponse<any, Error, "request-otp", RequestOTPArgs> => {
  const httpClient: AxiosInstance = useHttpClient();
  return useSWRMutation(
    "request-otp",
    async (_key, { arg }: { arg: RequestOTPArgs }): Promise<any> =>
      httpClient.post("/auth/otp", { type: arg.type }).then((res) => res.data)
  );
};

export default useRequestOTP;
